import React, { createContext, useContext, useState, useCallback } from 'react';

const ErrorContext = createContext();

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};

export const ErrorProvider = ({ children }) => {
  const [networkError, setNetworkError] = useState({
    isVisible: false,
    message: ''
  });

  const showNetworkError = useCallback((message = "זוהה תקלה באפליקציה ויטופל בהקדם אמכם הסליחה") => {
    setNetworkError({
      isVisible: true,
      message
    });
  }, []);

  const hideNetworkError = useCallback(() => {
    setNetworkError({
      isVisible: false,
      message: ''
    });
  }, []);

  // Global error handler for unhandled promise rejections
  React.useEffect(() => {
    const handleUnhandledRejection = (event) => {
      if (event.reason?.message === 'NETWORK_ERROR') {
        event.preventDefault(); // Prevent console error
        showNetworkError();
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);
    return () => window.removeEventListener('unhandledrejection', handleUnhandledRejection);
  }, [showNetworkError]);

  const value = {
    networkError,
    showNetworkError,
    hideNetworkError
  };

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
};